import { z } from 'zod';
/** Cloud machines (doc 51): what the agent recognises, how it is labelled, where its console is. */
export const CloudProviderSchema = z.enum(['gcp', 'runpod', 'scaleway']);
/** Ids end up in console links: nothing but this charset. */
const CloudId = z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/);
export const CloudInfoSchema = z.object({
    provider: CloudProviderSchema,
    instanceId: CloudId.nullable(),
    name: CloudId.nullable(),
    instanceType: CloudId.nullable(),
    zone: CloudId.nullable(),
    region: CloudId.nullable(),
    project: CloudId.nullable(),
    spot: z.boolean().nullable(),
    /** Whether the machine can stop itself so billing stops (doc 52). */
    selfStop: z.enum(['ok', 'needs-sudo', 'missing-key', 'unsupported']),
});
export const CLOUD_PROVIDERS = Object.freeze({
    gcp: { label: 'Google Cloud', console: 'https://console.cloud.google.com/compute/instances' },
    runpod: { label: 'RunPod', console: 'https://console.runpod.io/pods' },
    scaleway: { label: 'Scaleway', console: 'https://console.scaleway.com/instance/servers' },
});
/** The provider's own page for this machine, or its machine list when the details are missing. */
export function cloudConsoleUrl(cloud) {
    const seg = encodeURIComponent;
    if (cloud.provider === 'gcp' && cloud.zone && cloud.name && cloud.project) {
        return `https://console.cloud.google.com/compute/instancesDetail/zones/${seg(cloud.zone)}/instances/${seg(cloud.name)}?project=${seg(cloud.project)}`;
    }
    if (cloud.provider === 'scaleway' && cloud.zone && cloud.instanceId) {
        return `https://console.scaleway.com/instance/servers/${seg(cloud.zone)}/${seg(cloud.instanceId)}/overview`;
    }
    return CLOUD_PROVIDERS[cloud.provider].console;
}
/** The one wording for cloud costs (Jan, 2026-10-19): Couch tries, the user checks, no liability. */
export const CLOUD_COST_WARNING = 'Cloud machines cost money while they run. Couch tries to stop this machine when it is idle, '
    + 'but cannot guarantee it — check your provider\'s console and bill yourself. Couch takes no liability for cloud costs.';
//# sourceMappingURL=cloud.js.map